module.exports = __webpack_public_path__ + "static/media/vuesax-linear-user-edit.9b4b0c71.svg";